export const ORGANIZER_VERIFICATION_REQUIRED = 'organizer_verification_required'

const key = (roomName: string) => `organizer-verification:${roomName}`

export function requireOrganizerVerification(roomName: string): void {
  if (typeof sessionStorage === 'undefined') return
  sessionStorage.removeItem('isAdmin')
  sessionStorage.removeItem('isCurator')
  sessionStorage.setItem(key(roomName), 'true')
}

export function needsOrganizerVerification(roomName: string): boolean {
  return typeof sessionStorage !== 'undefined' && sessionStorage.getItem(key(roomName)) === 'true'
}

export function clearOrganizerVerification(roomName: string): void {
  if (typeof sessionStorage !== 'undefined') sessionStorage.removeItem(key(roomName))
}
